var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2508 4.01216H16C17.1046 4.01216 18 4.90759 18 6.01216V8.02456V9.52456V12.5431V14.0431V15.0555C18 16.7124 16.6569 18.0555 15 18.0555H3C1.34315 18.0555 0 16.7124 0 15.0555V6.01216C0 4.90759 0.895431 4.01216 2 4.01216H4.8743L11.3586 0.256819C12.0755 -0.158356 12.9917 0.0871256 13.4049 0.805119L15.2508 4.01216ZM13.5201 4.01216L12.1069 1.55686L7.86734 4.01216H13.5201ZM16 5.51216H2C1.72386 5.51216 1.5 5.73602 1.5 6.01216V15.0555C1.5 15.884 2.17157 16.5555 3 16.5555H15C15.8284 16.5555 16.5 15.884 16.5 15.0555V14.0431H11C9.89543 14.0431 9 13.1477 9 12.0431V10.0246C9 8.91999 9.89543 8.02456 11 8.02456H16.5V6.01216C16.5 5.73602 16.2761 5.51216 16 5.51216ZM16.5 9.52456V12.5431H11C10.7239 12.5431 10.5 12.3193 10.5 12.0431V10.0246C10.5 9.74841 10.7239 9.52456 11 9.52456H16.5Z",
    fill: "#101828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3994551bb5bc3941e4cbef16f5ab3f96.svg";
export { ForwardRef as ReactComponent };